<script setup lang="ts">
const props = defineProps<{
  name?: string
  icon?: string
  to?: any
  count?: number
}>()

defineExpose({
  name: props.name,
})
</script>

<template>
  <v-tab-item class="pa-4">
    <slot />
  </v-tab-item>
</template>
